<nz-modal
  [(nzVisible)]="showModal"
  nzTitle="Export Search Results"
  [nzContent]="modalContent"
  [nzFooter]="null"
  [nzWidth]="450"
  (nzOnCancel)="handleCancelForExportEmbargo()"
>
  <ng-template #modalContent>
    <div nz-row class="export-content-wrapper">
      <div class="label-text" nz-col nzSpan="5">
        Format
      </div>
      <div nz-col nzSpan="6">
        <nz-select [(ngModel)]="selectedFileType">
          <nz-option
            *ngFor="let fileType of fileTypes"
            [nzValue]="fileType.value"
            [nzLabel]="fileType.label"
          ></nz-option>
        </nz-select>
      </div>
      <div nz-col nzSpan="12">
        <button
          nz-button
          nzType="default"
          class="button-separator"
          (click)="handleCancelForExportEmbargo()"
        >
          Cancel
        </button>
        <button
          nz-button
          nzType="primary"
          class="button-separator"
          (click)="export()"
        >
          Export
        </button>
      </div>
    </div>
  </ng-template>
</nz-modal>
